import React from 'react';

export function AudioPreview({ url }: { url: string }) {
  return (
    <audio
      src={url}
      controls
      loop={false}
      playsInline
      preload="auto"
      crossOrigin="anonymous"
    >
      <track kind="captions" />
    </audio>
  );
}
